import Machine from './Machine'

class Machines {

    initialized = false;

    constructor(result) {

        this.machines = [];

        if (result) {
            for (let ix in result) {
                let m = new Machine(result[ix]);

                this.machines.push(m);
            }

            this.initialized = true;
        }

    }

    /**
     *
     * @param sort - null or "machine_id"
     * @param dir - can be "asc" or "desc"
     * @returns [Machine]
     */
    getAllMachines(sort, dir) {

        if (sort) {
            // Sort via comparator
            if (sort === 'machine_id' && dir === 'desc') {
                return this.machines.sort((a, b) => a.machine_id < b.machine_id);
            } else if (sort === 'machine_id') {
                return this.companies.sort((a, b) => a.machine_id > b.machine_id);
            }
        }

        // Fallback unsorted
        return this.machines;

    }

    getAllMachineIds() {

        return this.machines.map(
            (machine) => {
                return machine.machine_id;
            }
        );

    }

    getAllOrderedMachineIds() {

        const machineIds = [];
        const machines = this.machines.filter(
            (machine) => {
                return machine.machine_order !== null;
            }
        );

        machines.forEach((machine) => {
            machineIds.push(machine.machine_id);
        });

        return machineIds;

    }

    getAllMachineIdsFromLocation(id) {

        const locationMachines = this.getMachinesByLocationId(id);

        return locationMachines.map(
            (machine) => {
                return String(machine.machine_id);
            }
        );

    }

    getMachineByMachineId(mid) {

        if (mid === null) return [];

        return this.machines.find(
            (machine) => {
                return String(machine.machine_id) === String(mid)
            }
        );

    }

    getMachineByDbId(id) {

        if (id === null) return [];

        return this.machines.find(
            (machine) => {
                return +(machine.id) === +(id)
            }
        );

    }

    getMachineHeadsByMachineId(mid) {

        if (mid === null) return 1;

        const machine = this.getMachineByMachineId(mid);

        return (machine) ? machine.getHeads() : 1;

    }

    getMachineNeedlesByMachineId(mid) {

        if (mid === null) return 1;

        const machine = this.getMachineByMachineId(mid);

        return (machine) ? machine.getNeedles() : 1;

    }

    getMachinesByLocationId(id) {

        if (id === null) return [];
        if (id === 0) return this.machines;

        return this.machines.filter(
            (machine) => {
                return +(machine.id_location) === +(id);
            }
        );

    }

    getMachinesByCompanyId(id) {

        if (id === null) return [];
        if (id === 0) return this.machines;

        return this.machines.filter(
            (machine) => {
                return +(machine.id_company) === +(id);
            }
        );

    }

}

export default Machines;